import {
  BarChart3Icon,
  BookOpenIcon,
  BrainIcon,
  BriefcaseIcon,
  CalendarCheckIcon,
  ClipboardCheckIcon,
  ClipboardListIcon,
  CompassIcon,
  DumbbellIcon,
  FileTextIcon,
  FlowerIcon,
  FolderOpenIcon,
  GraduationCapIcon,
  HeartIcon,
  HelpCircleIcon,
  LayersIcon,
  LineChartIcon,
  ListChecksIcon,
  MessageSquareTextIcon,
  NetworkIcon,
  PenLineIcon,
  RouteIcon,
  SearchIcon,
  StethoscopeIcon,
  UsersIcon,
  UserRoundIcon,
} from 'lucide-react';
import type { Bonus, Faq, IconItem, KitModule } from '../types/landing';



export const preparationTasks: IconItem[] = [
  { label: 'Buscar preguntas', icon: SearchIcon },
  { label: 'Crear fichas', icon: FileTextIcon },
  { label: 'Pensar ejercicios', icon: BrainIcon },
  { label: 'Armar actividades', icon: PenLineIcon },
  { label: 'Preparar sesiones', icon: CalendarCheckIcon },
  { label: 'Ordenar materiales', icon: FolderOpenIcon },
];

export const familiarThoughts = [
  'Necesito una ficha para esta consulta.',
  '¿Qué ejercicio puedo utilizar?',
  'Quiero trabajar esta temática y no tengo material preparado.',
  'Necesito organizar una próxima sesión.',
  'Termino buscando recursos a último momento.',
];

export const accessSteps = [
  { title: 'Accedés', text: 'Ingresás al contenido desde tu celular, tablet o computadora.' },
  { title: 'Elegís', text: 'Buscás el módulo o recurso que necesitás.' },
  { title: 'Usás y adaptás', text: 'Consultás el material y lo adaptás a tu práctica profesional.' },
];

export const kitModules: KitModule[] = [
  {
    number: 1,
    title: 'Mapa de consulta:',
    subtitle: 'Evaluación y exploración sexual',
    description: 'Guías de entrevista, preguntas de exploración y fichas para ordenar la primera consulta.',
    includes: ['Guía de entrevista', 'Preguntas de exploración', 'Ficha de historia sexual'],
    tone: 'cream',
    icon: CompassIcon,
    cover: 'https://cdn.magicpatterns.com/uploads/4yXHGdbz2uZS1UfYmhqg3Z/WhatsApp_Image_2026-10-02_at_02.03.40_(1).jpg',
  },
  {
    number: 2,
    title: 'Deseo, placer y conexión',
    description: 'Recursos y preguntas guía para abordar deseo, placer y conexión en consulta.',
    includes: ['Preguntas guía', 'Ejercicios', 'Fichas de trabajo'],
    tone: 'coral',
    icon: HeartIcon,
    cover: 'https://cdn.magicpatterns.com/uploads/5M3Q5MHKgZU78mKuqAjvkk/WhatsApp_Image_2026-10-02_at_02.03.40_(2).jpg',
  },
  {
    number: 3,
    title: 'Dificultades sexuales:',
    subtitle: 'Herramientas de intervención',
    description: 'Herramientas organizadas por temática para planificar intervenciones con claridad.',
    includes: ['Herramientas por temática', 'Técnicas de intervención', 'Fichas de apoyo'],
    tone: 'mist',
    icon: BrainIcon,
    cover: 'https://cdn.magicpatterns.com/uploads/ahCi6ahQZ567fG5FLnLfhD/WhatsApp_Image_2026-10-02_at_02.03.40_(3).jpg',
  },
  {
    number: 4,
    title: 'Cuerpo, autoestima y placer',
    description: 'Actividades sobre imagen corporal, autoestima y vínculo con el propio placer.',
    includes: ['Actividades', 'Preguntas de reflexión', 'Ejercicios corporales'],
    tone: 'peach',
    icon: FlowerIcon,
    cover: 'https://cdn.magicpatterns.com/uploads/vsmPKK7xHHMVSWqzYsUYg6/WhatsApp_Image_2026-10-02_at_02.03.41.jpg',
  },
  {
    number: 5,
    title: 'Parejas y comunicación sexual',
    description: 'Material para trabajar comunicación, acuerdos y dinámica sexual en parejas.',
    includes: ['Dinámicas de pareja', 'Guías de comunicación', 'Tareas compartidas'],
    tone: 'rose',
    icon: UsersIcon,
    cover: 'https://cdn.magicpatterns.com/uploads/wqRCjmZmb1jUJuMUb38tFq/WhatsApp_Image_2026-10-02_at_02.03.41_(1).jpg',
  },
  {
    number: 6,
    title: 'Intervenciones prácticas',
    description: 'Ejercicios, tareas intersesión y técnicas listas para adaptar a cada caso.',
    includes: ['Ejercicios', 'Tareas intersesión', 'Técnicas adaptables'],
    tone: 'sage',
    icon: ListChecksIcon,
    cover: 'https://cdn.magicpatterns.com/uploads/8aj6E4yqExe3bhVM8DPHVP/WhatsApp_Image_2026-10-02_at_02.03.41_(2).jpg',
  },
  {
    number: 7,
    title: 'Sesiones listas',
    description: 'Sesiones resueltas con objetivos, estructura, preguntas y recursos como base de trabajo.',
    includes: ['Objetivos', 'Estructura de sesión', 'Preguntas y recursos'],
    tone: 'sand',
    icon: CalendarCheckIcon,
    cover: 'https://cdn.magicpatterns.com/uploads/8rcLSQEr2ZSQ1JwADouiiD/WhatsApp_Image_2026-10-02_at_02.03.41_(3).jpg',
  },
];

export const resourcePieces: IconItem[] = [
  { label: 'Fichas', icon: FileTextIcon },
  { label: 'Preguntas guía', icon: HelpCircleIcon },
  { label: 'Ejercicios', icon: DumbbellIcon },
  { label: 'Sesiones', icon: CalendarCheckIcon },
  { label: 'Evaluación inicial', icon: ClipboardCheckIcon },
  { label: 'Plan de intervención', icon: RouteIcon },
  { label: 'Seguimiento', icon: LineChartIcon },
  { label: 'Material para consultorio', icon: BriefcaseIcon },
];

export const beforeItems = [
  'Buscar ejercicios por internet',
  'Crear fichas desde cero',
  'Preparar cada sesión',
  'Tener recursos desperdigados',
  'Buscar material a último momento',
  'Organizar manualmente el seguimiento',
];

export const afterItems = [
  'Biblioteca organizada',
  '+60 Sesiones listas',
  'Preguntas y fichas preparadas',
  'Ejercicios disponibles',
  'Todo en un solo lugar',
  'Acceso fácil desde celular, tablet o computadora',
];

export const audiences: IconItem[] = [
  { label: 'Sexólogos/as', icon: HeartIcon },
  { label: 'Psicólogos/as', icon: UserRoundIcon },
  { label: 'Profesionales formados en sexualidad', icon: GraduationCapIcon },
  { label: 'Profesionales que ya atienden consultas relacionadas con sexualidad', icon: StethoscopeIcon },
];

export const bonuses: Bonus[] = [
  {
    number: 1,
    title: 'Kit de evaluación inicial',
    description: 'Fichas y cuestionarios para ordenar la primera entrevista.',
    icon: ClipboardListIcon,
    tone: 'petrol',
    image: 'https://cdn.magicpatterns.com/uploads/3JiNwjVbnxw26b24rhrxZ3/ChatGPT_Image_30_sept_2026,_21_06_26.png',
    imageWidth: 1200,
    imageHeight: 1300,
  },
  {
    number: 2,
    title: 'Banco de frases profesionales',
    description: 'Frases para abrir temas sensibles, validar y encuadrar la consulta.',
    icon: MessageSquareTextIcon,
    tone: 'terra',
    image: 'https://cdn.magicpatterns.com/uploads/g7wFLiwb9dcNDLPHPJhuEN/ChatGPT_Image_30_sept_2026,_21_14_44.png',
    imageWidth: 1312,
    imageHeight: 1200,
  },
  {
    number: 3,
    title: 'Sistema de seguimiento profesional',
    description: 'Plantillas para registrar avances y ordenar la evolución de cada caso.',
    icon: BarChart3Icon,
    tone: 'petrol',
    image: 'https://cdn.magicpatterns.com/uploads/fv1XHtPPdqMaS3LLAQcaQE/ChatGPT_Image_30_sept_2026,_21_14_40.png',
    imageWidth: 1312,
    imageHeight: 1200,
  },
  {
    number: 4,
    title: 'Mapa de decisión profesional',
    description: 'Esquemas para ordenar próximos pasos según lo que surge en consulta.',
    icon: NetworkIcon,
    tone: 'terra',
    image: 'https://cdn.magicpatterns.com/uploads/mEE5TbbnvBCjPdqPPvm1eo/ChatGPT_Image_30_sept_2026,_21_11_23.png',
    imageWidth: 1312,
    imageHeight: 1200,
  },
  {
    number: 5,
    title: 'Kit profesional de consultorio',
    description: 'Material de apoyo para el día a día de tu consultorio.',
    icon: BriefcaseIcon,
    tone: 'petrol',
    image: 'https://cdn.magicpatterns.com/uploads/t8enayyBG62g8AasW7LG8u/ChatGPT_Image_30_sept_2026,_21_13_17.png',
    imageWidth: 1312,
    imageHeight: 1200,
  },
];

export const valueStack: IconItem[] = [
  { label: '7 módulos', icon: BookOpenIcon },
  { label: '5 bonos de regalo', icon: LayersIcon },
  { label: '+60 Sesiones listas', icon: CalendarCheckIcon },
  { label: 'Fichas', icon: FileTextIcon },
  { label: 'Preguntas guía', icon: HelpCircleIcon },
  { label: 'Ejercicios', icon: DumbbellIcon },
  { label: 'Herramientas profesionales', icon: BriefcaseIcon },
  { label: 'Acceso digital', icon: FolderOpenIcon },
];

export const securityItems = [
  'Pago seguro',
  'Acceso digital inmediato',
  'Disponible desde celular, tablet y computadora',
  'Material organizado y descargable',
];

export const faqs: Faq[] = [
  {
    question: '¿Qué es Kit Sexualidad Práctica?',
    answer:
      'Es una biblioteca digital de recursos profesionales para trabajar con sexualidad, con sesiones, fichas, preguntas, ejercicios y herramientas organizadas en 7 módulos.',
  },
  { question: '¿Qué incluye?', answer: '7 módulos completos + 5 bonos de regalo.' },
  { question: '¿Desde dónde puedo acceder?', answer: 'Desde celular, tablet o computadora.' },
  {
    question: '¿Cuándo recibo el material?',
    answer: 'El acceso es digital e inmediato luego de completar la compra.',
  },
  {
    question: '¿Tiene garantía?',
    answer: 'Sí. Tenés 7 días de garantía desde tu compra para revisar el material con tranquilidad.',
  },
  {
    question: '¿Es un curso?',
    answer:
      'No. El enfoque principal es ofrecer recursos y materiales prácticos para consultar y adaptar a la práctica profesional.',
  },
  {
    question: '¿Para quién está pensado?',
    answer:
      'Para sexólogos/as, psicólogos/as y profesionales debidamente formados que trabajan con sexualidad.',
  },
];
